var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","css":false},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_c('div',{ref:"container",class:("VideoPoster " + _vm.className),style:(_vm.styleObject),on:{"click":_vm.onClickHandler}},[(_vm.hasPlayButton)?_c('button',{attrs:{"aria-label":"Play Video"}},[_c('play-icon')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b44b2a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/foo/components/VideoPoster.vue
// module id = null
// module chunks = 